function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M274 15c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L274 17h-3v12h12v-3c0-.513.386-.936.883-.993L284 25c.513 0 .936.386.993.883L285 26v4c0 .513-.386.936-.883.993L284 31h-14c-.513 0-.936-.386-.993-.883L269 30V16c0-.513.386-.936.883-.993L270 15h4zm10 0c.513 0 .936.386.993.883L285 16v5c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L283 21v-2.586l-6.293 6.293c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.094L281.584 17H279c-.513 0-.936-.386-.993-.883L278 16c0-.513.386-.936.883-.993L279 15h5z",
  transform: "translate(-269 -220) translate(0 205)"
}))));
function SvgExternalLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "media/external-link.19c8dad3a364c625780f5267b4a50f17.svg";
export { ForwardRef as ReactComponent };